module.exports = "/images/ny-life1-3.jpg";